<template>
  <div>
    <div>
      <span v-if="statusType !== 'expired'"
        >{{ minutes }}:{{ seconds }}</span
      >
      <span  v-else>{{ message }}</span>
    </div>
  </div>
</template>

<script>
import jwtDecode from "jwt-decode";
// import store from "../../store";

export default {
  name: "CountDown",
  props: ["starttime", "endtime", "trans"],
  data: () => ({
    timer: "",
    wordString: {},
    start: "",
    end: "",
    interval: "",
    days: "",
    minutes: "",
    hours: "",
    seconds: "",
    message: "",
    statusType: "",
    statusText: ""
  }),
  created: function() {
    this.wordString = JSON.parse(this.trans);
  },
  mounted() {
    const decode = jwtDecode(localStorage.getItem("token"));
    let dateCount = new Date(decode.exp * 1000);
    this.start = new Date();
    this.end = dateCount;
    // Update the count down every 1 second
    this.timerCount(this.start, this.end);
    this.interval = setInterval(() => {
      this.timerCount(this.start, this.end);
    }, 1000);
  },
  methods: {
    timerCount: function(start, end) {
      // Get todays date and time
      var now = new Date().getTime();

      // Find the distance between now an the count down date
      var distance = start - now;
      var passTime = end - now;

      if (distance < 0 && passTime < 0) {
        //this.dispatch("logout");
        this.message = this.wordString.expired;
        this.statusType = "expired";
        //this.statusText = this.wordString.status.expired;
        location.href = "https://console.kyamipay.ao";
        clearInterval(this.interval);
      } else if (distance < 0 && passTime > 0) {
        this.calcTime(passTime);
        //this.message = this.wordString.running;
        this.statusType = "running";
        //this.statusText = this.wordString.status.running;
      } else if (distance > 0 && passTime > 0) {
        this.calcTime(distance);
        //this.message = this.wordString.upcoming;
        this.statusType = "upcoming";
        //this.statusText = this.wordString.status.upcoming;
      }
    },
    calcTime: function(dist) {
      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
        (dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minZero = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      let secZero = Math.floor((dist % (1000 * 60)) / 1000);

      if (minZero < 10) {
        this.minutes = "0" + minZero;
      } else {
        this.minutes = minZero;
      }

      if (secZero < 10) {
        this.seconds = "0" + secZero;
      } else {
        this.seconds = secZero;
      }
    }
  }
};
</script>

<style scoped></style>
